import { connect } from 'react-redux';
import { fetchDriverProperties } from '../../../../../../actions';
import { Button, Card, Modal } from 'react-bootstrap';
import PropertyPickerVertical from './components/PropertyPickerVertical';
import BaseFeature from './BaseFeature';
import { LED_MODULE } from '../../../../../../utils/constantFeatures';
import { Trans } from 'react-i18next';

class LedModule extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            isEnabled: false,
            // ledModule: ''
            isShowingResetCurrent: false,
        };

        this.handleChange = this.handleChange.bind(this);
        // this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    }

    handleChange(propertyName, value) {

        const v = value;
        if(propertyName === 'led.ser'){
            this.setState({isShowingResetCurrent: true});
        }

        this.props.handleChange(propertyName, v);

    }

    // handleChangeDropdown(e) {
    //     const v = e.target.name;
    //     const i = e.target.id;

    //     this.setState({ ledModule: v });
    //     this.props.handleChange(this.props.properties[LED_MODULE.id].info.name, i);

    // }

    // renderDropdownItems() {
    //     let dropdownItems = [];

    //     this.props.ledmodules.forEach(prop => {
    //         dropdownItems.push(
    //             <Dropdown.Item onClick={this.handleChangeDropdown} name={prop.name} id={prop.id} key={prop.id}>{prop.name}</Dropdown.Item>
    //         );
    //     });

    //     return dropdownItems;
    // }

    componentDidMount() {
        this.props.fetchDriverProperties(this.props.project.id, this.props.driver.driverId);
        // this.props.fetchLedModules()
        //     .then(() => {
        //         const ledModuleId = this.props.properties[LED_MODULE.id].value
        //         if (ledModuleId) {
        //             const ledModuleSelected = this.props.ledmodules.filter(x => x.id === parseInt(ledModuleId))[0];
        //             this.setState({ ledModule: ledModuleSelected.name });
        //         }
        //     }).catch(() => {
        //     });

    }

    render() {

        //const mode = this.props.properties[LED_MODULE.mode]; //TO SHOW?
        const currentWarmWhite = this.props.properties[LED_MODULE.currentWarmWhite];
        const warmWhiteLuminous = this.props.properties[LED_MODULE.warmWhiteLuminous];
        const coldWhiteColor = this.props.properties[LED_MODULE.coldWhiteColor];
        const currentColdWhite = this.props.properties[LED_MODULE.currentColdWhite];
        const warmWhiteColor = this.props.properties[LED_MODULE.warmWhiteColor];
        const coldWhiteLuminous = this.props.properties[LED_MODULE.coldWhiteLuminous];
        // const id = this.props.properties[LED_MODULE.id];
        const ambientTemperature = this.props.properties[LED_MODULE.ambientTemperature];
        const temperatureWarm = this.props.properties[LED_MODULE.temperatureWarm];
        const temperatureCold = this.props.properties[LED_MODULE.temperatureCold];
        const coldX = this.props.properties[LED_MODULE.coldX];
        const coldY = this.props.properties[LED_MODULE.coldY];
        const warmX = this.props.properties[LED_MODULE.warmX];
        const warmY = this.props.properties[LED_MODULE.warmY];
        var serialModelCount = this.props.properties[LED_MODULE.serialModuleCount];

        var modularity_enabled = false;
        if(this.props.properties[LED_MODULE.id].value >= 20 && this.props.properties[LED_MODULE.id].value <= 65535){
            modularity_enabled = true;
        } else {
            serialModelCount.value = 1;
        }

        return (
            <div>
                <Modal show={this.state.isShowingResetCurrent} onHide={() => this.setState({isShowingResetCurrent: false})} animation={false}>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ color: "#E95B0D" }}><Trans i18nKey="Warning" /></Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>
                            Changing modularity will reset current settings to default
                        </p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({isShowingResetCurrent: false}) }><Trans i18nKey="Close" /></Button>
                    </Modal.Footer>
                </Modal>
                {/* <div className="flex-row">
                    <Card className={this.getClassName([ambientTemperature])}>
                        <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                            {'Load LED Module'}
                        </div>
                        <Card.Body style={{ display: "flex" }} disabled={!this.state.isEnabled}>
                            <Row>
                                <Col sm={12} style={{ padding: "0" }}>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="secondary" className={`edit-icon-project-header dropdown-osram`}>{this.state.ledModule}</Dropdown.Toggle>
                                        <Dropdown.Menu style={{ minWidth: "auto", fontSize: "14px" }}>
                                            {this.renderDropdownItems()}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </div> */}
                <div className="flex-row" style={{ paddingTop: '0.75rem' }}>
                    <Card className={this.getClassName([ambientTemperature])}>
                        <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                            <Trans i18nKey="Ambient" />
                        </div>
                        <Card.Body style={{ display: "flex" }} disabled={!this.state.isEnabled || this.state.ledModule === ''}>
                            <PropertyPickerVertical
                                border={'border-none'}
                                disabled={this.state.ledModule === ''}
                                property={ambientTemperature}
                                title={<Trans i18nKey="Temperature" />}
                                measureUnit={ambientTemperature.info.unit}
                                min={ambientTemperature.valueMeta.min}
                                max={ambientTemperature.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                    <Card className={this.getClassName([serialModelCount])} style={{width: "565px"}}>
                        <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                            <Trans i18nKey="Modularity_serial" />
                        </div>
                        <Card.Body style={{ display: "flex", alignItems: 'flex-start', justifyContent: 'space-between'}} disabled={!this.state.isEnabled || this.state.ledModule === ''}>
                            <div>
                                <p>Enter number of LED modules connected in series</p>
                                <details>
                                    <summary>More:</summary>
                                    <p>
                                        Only the shortest module of a module family is available in the database. When operating longer modules of the same module family, Count needs to be increased accordingly<br/><br/>
                                        Example: Select LED Module and Count = 4 to operate 2x PL-LIN-Z2 2200-8TW 560-LV/1A4 LED modules connected in series.<br/><br/>
                                        The tool cannot compensate for 62mm or 70mm boards. Counter needs to be calculated pro-rata to the nearest Count * 280mm module.
                                    </p>
                                </details>
                            </div>
                            <div>
                                <PropertyPickerVertical
                                    border={'border-none'}
                                    disabled={this.state.ledModule === '' || !modularity_enabled}
                                    property={serialModelCount}
                                    title={'Count'}
                                    measureUnit={serialModelCount.info.unit}
                                    min={serialModelCount.valueMeta.min}
                                    max={serialModelCount.valueMeta.max}
                                    step={1}
                                    handleChange={this.handleChange} />
                            </div>
                        </Card.Body>
                    </Card>
                </div>

                <div className="flex-row" style={{ paddingTop: '0.75rem' }}>
                    <Card className={this.getClassName([temperatureCold, currentColdWhite, coldWhiteLuminous, coldX, coldY, coldWhiteColor])}>
                        <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                            <Trans i18nKey="Cold_White_CH1" />
                        </div>
                        <Card.Body style={{ display: "flex" }} disabled={!this.state.isEnabled || this.state.ledModule === ''}>
                            <PropertyPickerVertical
                                property={temperatureCold}
                                disabled={this.state.ledModule === ''}
                                border={'border-none'}
                                title={<Trans i18nKey="Module_Temperature" />}
                                measureUnit={temperatureCold.info.unit}
                                min={temperatureCold.valueMeta.min}
                                max={temperatureCold.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            {/* <PropertyPickerVertical
                                property={currentColdWhite}
                                title={currentColdWhite.info.displayName}
                                measureUnit={currentColdWhite.info.unit}
                                min={currentColdWhite.valueMeta.min}
                                max={currentColdWhite.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} /> */}
                            <PropertyPickerVertical
                                disabled={!this.state.isEnabled}
                                property={coldWhiteLuminous}
                                title={<Trans i18nKey="Luminous_Flux" />}
                                measureUnit={coldWhiteLuminous.info.unit}
                                min={coldWhiteLuminous.valueMeta.min}
                                max={coldWhiteLuminous.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                disabled={!this.state.isEnabled}
                                property={coldX}
                                border={'border-left-none'}
                                title={<Trans i18nKey="Color_X" />}
                                type={'float'}
                                measureUnit={coldX.info.unit}
                                min={coldX.valueMeta.min}
                                max={coldX.valueMeta.max}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                disabled={!this.state.isEnabled}
                                property={coldY}
                                border={'border-left-none'}
                                title={<Trans i18nKey="Color_Y" />}
                                type={'float'}
                                measureUnit={coldY.info.unit}
                                min={coldY.valueMeta.min}
                                max={coldY.valueMeta.max}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                disabled={!this.state.isEnabled}
                                property={coldWhiteColor}
                                border={'border-none'}
                                title={<Trans i18nKey="Color_Temperature" />}
                                measureUnit={coldWhiteColor.info.unit}
                                min={coldWhiteColor.valueMeta.min}
                                max={coldWhiteColor.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                </div>

                <div className="flex-row" style={{ paddingTop: '0.75rem' }}>
                    <Card className={this.getClassName([temperatureWarm, currentWarmWhite, warmWhiteLuminous, warmX, warmY, warmWhiteColor])}>
                        <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                            <Trans i18nKey="Warm_White_CH2" />
                        </div>
                        <Card.Body style={{ display: "flex" }} disabled={!this.state.isEnabled || this.state.ledModule === ''}>
                            <PropertyPickerVertical
                                property={temperatureWarm}
                                disabled={this.state.ledModule === ''}
                                border={'border-none'}
                                title={<Trans i18nKey="Module_Temperature" />}
                                measureUnit={temperatureWarm.info.unit}
                                min={temperatureWarm.valueMeta.min}
                                max={temperatureWarm.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            {/* <PropertyPickerVertical
                                property={currentWarmWhite}
                                title={currentWarmWhite.info.displayName}
                                measureUnit={currentWarmWhite.info.unit}
                                min={currentWarmWhite.valueMeta.min}
                                max={currentWarmWhite.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} /> */}
                            <PropertyPickerVertical
                                disabled={!this.state.isEnabled}
                                property={warmWhiteLuminous}
                                title={<Trans i18nKey="Luminous_Flux" />}
                                measureUnit={warmWhiteLuminous.info.unit}
                                min={warmWhiteLuminous.valueMeta.min}
                                max={warmWhiteLuminous.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                disabled={!this.state.isEnabled}
                                property={warmX}
                                border={'border-left-none'}
                                title={<Trans i18nKey="Color_X" />}
                                type={'float'}
                                measureUnit={warmX.info.unit}
                                min={warmX.valueMeta.min}
                                max={warmX.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                disabled={!this.state.isEnabled}
                                property={warmY}
                                border={'border-left-none'}
                                title={<Trans i18nKey="Color_Y" />}
                                type={'float'}
                                measureUnit={warmX.info.unit}
                                min={warmX.valueMeta.min}
                                max={warmX.valueMeta.max}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                disabled={!this.state.isEnabled}
                                property={warmWhiteColor}
                                border={'border-none'}
                                title={<Trans i18nKey="Color_Temperature" />}
                                measureUnit={warmWhiteColor.info.unit}
                                min={warmWhiteColor.valueMeta.min}
                                max={warmWhiteColor.valueMeta.max}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                </div>

                <div className="flex-col led-module-bottom-text" style={{ paddingTop: '0.75rem', textAlign: 'left' }}>
                    <div>
                        To ensure DALI compliance, the operating current values must be chosen to achieve flux equity of both channels.
                    </div>
                    <div style={{ paddingTop: '0.75rem' }}>
                        <Trans i18nKey="Driver_Compatibility_Warning" /><br/>
                        Please check datasheets to find a match with respect to
                        <ul><li>SELV / non-isolated</li>
                            <li>Voltage/Current output window</li></ul>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        validationSummary: state.project.validationSummary,
        // ledmodules: state.ledModules.ledmodules
    };
};

const mapDispatchToProps = {
    fetchDriverProperties,
    // fetchLedModules
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LedModule);
